
import {
  BodyStyle,
  HeaderStyle1,
  HeaderStyleSimpleSOE1,
  HeaderStyleSimpleSOE2,
  getCellType,
} from "../../../../../app/contexts/helpers";
import {
  INITIAL_RISK_ASSESSMENT_COLORS,
  VSS_HEADER_COLORS,
} from "../../constants";

const returnHeaderColor = (value) => {
  if (value === "Low")
    return INITIAL_RISK_ASSESSMENT_COLORS.GREEN.replace("#", "");
  if (value === "Moderate")
    return INITIAL_RISK_ASSESSMENT_COLORS.YELLOW.replace("#", "");
  if (value === "High")
    return INITIAL_RISK_ASSESSMENT_COLORS.RED.replace("#", "");
  return "D3D3D3";
};

const returnTotalColor = (total) => {
  if (total > 26) {
    return INITIAL_RISK_ASSESSMENT_COLORS.RED.replace("#", "");
  } else if (total > 18 && total <= 26) {
    return INITIAL_RISK_ASSESSMENT_COLORS.YELLOW.replace("#", "");
  } else {
    return INITIAL_RISK_ASSESSMENT_COLORS.GREEN.replace("#", "");
  }
};

// Function to style visit sampling strategy table content
export const styleVisitSamplingStrategyTableContent = (tableContent) => {
  const styledTableContent = [];
  let colorIndex = 0;
  let isHeader = true;
  for (let i = 0; i < tableContent.length; i++) {
    const color =
      VSS_HEADER_COLORS[Math.min(colorIndex, VSS_HEADER_COLORS.length - 1)];
    if (!styledTableContent[i]) styledTableContent.push([]);
    for (let j = 0; j < tableContent[i].length; j++) {
      const value = tableContent[i][j];
      const type = getCellType(value);
      styledTableContent[i].push({
        v: value ?? "",
        ...(type === "d" ? { z: "dd mmm yyyy" } : {}),
        t: type,
        s: isHeader
          ? { ...HeaderStyle1, fill: { fgColor: { rgb: color } } }
          : j === 0
          ? {
              ...BodyStyle,
              alignment: { wrapText: true, horizontal: "right" },
            }
          : BodyStyle,
      });
    }

    isHeader = tableContent[i].every((item) => item === "");
    if (isHeader) colorIndex++;
  }
  return styledTableContent;
};

// Function to style table content
export const styleTableContent = (tableContent) => {
  const styledTableContent = [];
  for (let i = 0; i < tableContent.length; i++) {
    if (!styledTableContent[i]) styledTableContent.push([]);
    for (let j = 0; j < tableContent[i].length; j++) {
      const value = tableContent[i][j];
      const type = getCellType(value);
      styledTableContent[i].push({
        v: value ?? "",
        ...(type === "d" ? { z: "dd mmm yyyy" } : {}),
        t: type,
        s: i === 0 ? HeaderStyle1 : BodyStyle,
      });
    }
  }
  return styledTableContent;
};

// Function to style risk assessment table content
export const styleRiskAssessmentTableContent = (tableContent) => {
  const styledTableContent = [];
  for (let i = 0; i < tableContent.length; i++) {
    if (!styledTableContent[i]) styledTableContent.push([]);
    for (let j = 0; j < tableContent[i].length; j++) {
      const value = tableContent[i][j];
      const type = getCellType(value);
      styledTableContent[i].push({
        v: value ?? "",
        ...(type === "d" ? { z: "dd mmm yyyy" } : {}),
        t: type,
        s:
          i === 0
            ? {
                ...HeaderStyle1,
                fill: { fgColor: { rgb: returnHeaderColor(value) } },
              }
            : {
                ...BodyStyle,
                alignment: { wrapText: true, horizontal: "left" },
                ...(i === 12 && j === 2
                  ? {
                      fill: { fgColor: { rgb: returnTotalColor(value) } },
                      alignment: { wrapText: true, horizontal: "center" },
                    }
                  : {}),
              },
      });
    }
  }
  return styledTableContent;
};

const getCellStyle = (rowIndex, columnIndex) => {
  if (columnIndex === 0) {
    return HeaderStyleSimpleSOE2;
  } else if (rowIndex === 0) {
    return HeaderStyleSimpleSOE1;
  } else {
    return BodyStyle;
  }
}

// Function to style table content
export const styleSimpleSOETableContent = (tableContent) => {
  const styledTableContent = [];
  for (let column = 0; column < tableContent.length; column++) {
    if (!styledTableContent[column]) styledTableContent.push([]);
    for (let row = 0; row < tableContent[column].length; row++) {
      const cellValue = tableContent[column][row];
      const type = getCellType(cellValue);
      
      styledTableContent[column].push({
        v: cellValue ?? "",
        t: type,
        s: getCellStyle(row, column),
      });
    }
  }
  return styledTableContent;
};